import { createApp } from "vue";
import PrimeVue from "primevue/config";
import "primeicons/primeicons.css";

import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import DialogService from "primevue/dialogservice";
import Tooltip from "primevue/tooltip";
import Aura from "@primeuix/themes/aura";
import { definePreset } from "@primeuix/themes";

import LoginApp from "../LoginApp.vue";

// Indigo 品牌色 preset (与 roletw 保持一致)
const LoginPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: "#eef2ff",
            100: "#e0e7ff",
            200: "#c7d2fe",
            300: "#a5b4fc",
            400: "#818cf8",
            500: "#6366f1", // 主色
            600: "#4f46e5",
            700: "#4338ca",
            800: "#3730a3",
            900: "#312e81",
            950: "#1e1b4b",
        },
    },
});

// 创建并挂载 Vue 应用
const app = createApp(LoginApp);

app.use(PrimeVue as any, {
    locale: {
    firstDayOfWeek: 1,
    dayNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    dayNamesShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    dayNamesMin: ['日', '一', '二', '三', '四', '五', '六'],
    monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    today: '今天',
    clear: '清空',
    dateFormat: 'yy/mm/dd',
    weekHeader: '周',
    emptyMessage: '无可用选项',
    emptyFilterMessage: '未找到结果',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  },
    theme: {
        preset: LoginPreset,
        options: {
            darkModeSelector: ".never-match-dark-mode",
        },
    },
});

app.use(ConfirmationService as any);
app.use(ToastService as any);
app.use(DialogService as any);
app.directive("tooltip", Tooltip as any);
app.mount("#vue-login");
